import { render, staticRenderFns } from "./ChatSuggestions.vue?vue&type=template&id=127a5146&scoped=true&"
import script from "./ChatSuggestions.vue?vue&type=script&lang=js&"
export * from "./ChatSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./ChatSuggestions.vue?vue&type=style&index=0&id=127a5146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a5146",
  null
  
)

export default component.exports